module.exports = __webpack_public_path__ + "img/appxz.a0bccad9.png";